
import noDataLabel from "../common/no-data-label.vue";
const CHANNELS = ["Zomato", "Swiggy", "Whatsapp"];
export default {
  components: { noDataLabel },
  data() {
    return {
      series: [25, 25, 50],
      chartOptions: {
        labels: CHANNELS,
        colors: ["#28D484", "#FF654E", "#FFC830"],
        chart: {
          type: "donut",
          width: "500px",
          height: "400px"
        },
        plotOptions: {
          pie: {
            donut: {
              size: 50,
              width: "1000px",

              labels: {
                show: true
              }
            }
          }
        },
        legend: {
          position: "bottom"
        }
      }
    };
  }
};
